// Export the Component Definition for use in Contentful Studio
export {ActionBlockCarouselContentfulComponentDefinition} from './actionBlockCarouselContentfulDefinition';
export {default} from './ActionBlockCarousel';
